@if (assertion(data)) {
	<a (click)="onLinkClick($event)">
		{{ value }}
	</a>
} @else {
	{{ value }}
}

